// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__Xvf_u","author":"Table_author__2xHZ0","authorImage":"Table_authorImage__3xBal","unreadRow":"Table_unreadRow__2bj-h"};